// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../devices/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../devices/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".colour-selector[data-v-31570b81]{width:80%;margin-top:16px}img[data-v-31570b81]{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
